import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Modal, Button, Form, Container, TextArea, Dimmer, Loader, Message, Icon } from 'semantic-ui-react';
import LanguageEditor from 'widgets/bussiness/language-editor';
import SkillsEditor, { SkillType } from 'widgets/bussiness/skills-editor';
import {
  NewSsaQuestionBankStore,
  CreateSsaQuestionBankDto,
  SsaQuestionBankDto
} from 'stores/assessments/questionBank/ssa-questionBank-store';
import { LanguageDto, DropdownLanguagesStore } from 'stores/configuration/locations/languages-store';
import { nameof } from 'utils/object';
import TestCategorySelector from 'widgets/bussiness/selectors/test-category-selector';
import { Query, ItemReference } from 'stores/dataStore';
import { isNullOrWhiteSpaces } from 'utils/useful-functions';
import MultiProfessionEditor from 'widgets/bussiness/multi-profession-editor';
import i18n from 'i18n';
import { CreateQuestionDto, QuestionDto } from 'stores/assessments/questionBank/tna-questionBank-store';

interface NewSsaQuestionBankViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newQuestionBank?: NewSsaQuestionBankStore;
  languagesStore?: DropdownLanguagesStore;
  isClone?: boolean;
  cloneData: SsaQuestionBankDto;
}

interface NewSsaQuestionBankState {
  category: ItemReference;
  skill: ItemReference;
  userClickedSave: boolean;
  questionTranslations: CreateQuestionDto[];
  defaultLanguage: LanguageDto;
  query: Query;
}

@connect(['newQuestionBank', NewSsaQuestionBankStore], ['languagesStore', DropdownLanguagesStore])
class NewSsaQuestionBankView extends React.Component<NewSsaQuestionBankViewProps, NewSsaQuestionBankState> {
  private get newQuestionBankStore() {
    return this.props.newQuestionBank;
  }

  constructor(props: NewSsaQuestionBankViewProps) {
    super(props);
    let query: Query = {
      searchQuery: '',
      orderBy: [],
      skip: 0,
      take: 1000,
      filter: [{ or: [{ LanguageCode: 'EN-en' }, { Language: 'English' }] }]
    };

    this.newQuestionBankStore.createNew({
      question:
        this.props.isClone && this.props.cloneData
          ? { text: this.props.cloneData.question.text, languageId: this.props.cloneData.question.language.id }
          : null,
      testCategoryId: this.props.isClone && this.props.cloneData ? this.props.cloneData.testCategoryId : '',
      professions: this.props.isClone && this.props.cloneData ? this.props.cloneData.professions.map(p => p.id) : [],
      ssaSkillId: this.props.isClone && this.props.cloneData && this.props.cloneData.ssaSkillId ? this.props.cloneData.ssaSkillId : '',
      questionTranslations:
        this.props.isClone && this.props.cloneData ? this.mapToCreateQuestionDto(this.props.cloneData.questionTranslations) : []
    });
    this.state = {
      query,
      category:
        this.props.isClone && this.props.cloneData
          ? Object.assign({ id: this.props.cloneData.testCategoryId, title: this.props.cloneData.testCategory.name })
          : null,
      skill:
        this.props.isClone && this.props.cloneData && this.props.cloneData.ssaSkillId
          ? Object.assign({ id: this.props.cloneData.ssaSkillId, title: this.props.cloneData.ssaSkill.name })
          : null,
      userClickedSave: false,
      questionTranslations:
        this.props.isClone && this.props.cloneData ? this.mapToCreateQuestionDto(this.props.cloneData.questionTranslations) : [],
      defaultLanguage: null
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewSsaQuestionBankViewProps) {
    if (this.newQuestionBankStore.state.result && this.newQuestionBankStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  componentDidMount() {
    this.loadDefaulLanguage();
  }

  private loadDefaulLanguage() {
    this.props.languagesStore.getAllAsync(this.state.query).then(e => {
      var defLanguage = e.items.firstOrDefault(x => x.languageCode === 'EN-en' || x.language === 'English');
      this.setState({ defaultLanguage: defLanguage ? defLanguage : e.items[0] });
    });
  }

  @autobind
  private handleValue(property: string, value: any) {
    this.setState({ userClickedSave: false });
    const change = {};
    change[property] = value;
    this.newQuestionBankStore.change({ ...this.newQuestionBankStore.state.item, ...change });
  }

  private mapToCreateQuestionDto(items: QuestionDto[]): CreateQuestionDto[] {
    let data: CreateQuestionDto[] = [];
    items.forEach(i => {
      data.push({ text: i.text, languageId: i.language.id });
    });
    return data;
  }

  private onChangeQuestion(q: string) {
    let question = this.newQuestionBankStore.state.item.question;
    if (question) {
      question.text = q;
    } else {
      question = { text: q, languageId: this.state.defaultLanguage ? this.state.defaultLanguage.id : null };
    }
    this.handleValue(nameof<CreateSsaQuestionBankDto>('question'), question);
  }

  @autobind
  private onCreateNewItem() {
    this.setState({ userClickedSave: true });
    this.newQuestionBankStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newQuestionBankStore.clear();
    this.props.onClose(false);
  }

  addQuestionsTranslation = () => {
    let question = this.state.questionTranslations;
    question.push({ text: '', languageId: null });

    this.setState({ questionTranslations: question });
  };

  handleQuestionTransaltionTextChange = (index: number, questionText: string) => {
    let questionTranslations = this.state.questionTranslations;
    let question = questionTranslations[index];
    question.text = questionText;

    this.setState({ questionTranslations }, () =>
      this.handleValue(nameof<CreateSsaQuestionBankDto>('questionTranslations'), questionTranslations)
    );
  };

  handleQuestionTransaltionLanguageChange = (index: number, languageId: string) => {
    let questionTranslations = this.state.questionTranslations;
    let question = questionTranslations[index];
    question.languageId = languageId;
    this.setState({ questionTranslations }, () =>
      this.handleValue(nameof<CreateSsaQuestionBankDto>('questionTranslations'), questionTranslations)
    );
  };

  removeDateRange = index => {
    let questionTranslations = this.state.questionTranslations;
    questionTranslations.splice(index, 1);

    this.setState({ questionTranslations }, () =>
      this.handleValue(nameof<CreateSsaQuestionBankDto>('questionTranslations'), questionTranslations)
    );
  };

  showQuestionTranslationRows = () => {
    return this.state.questionTranslations.map((question, index) => {
      return (
        <Form.Group className="tna-question-bank__new-rows" key={`${question.languageId}_${index}`}>
          <Form.Field
            required
            className="tna-question-bank__label-textarea"
            error={this.state.userClickedSave && question.text.length === 0}
          >
            <TextArea
              maxLength="500"
              className="tna-question-bank__new-rows__textarea"
              value={question ? question.text : ''}
              onChange={(e, { value }) => this.handleQuestionTransaltionTextChange(index, value.toString())}
            />
          </Form.Field>
          <div className="tna-question-bank__new-rows__drop-remove">
            <LanguageEditor
              className={'planit-user-dropdown-custom'}
              nullable
              value={question.languageId}
              onChange={c => {
                this.handleQuestionTransaltionLanguageChange(index, c == null ? null : c.id);
              }}
              onlyForTests={true}
            />

            <div className="new-pattern__remove-icon">
              <Icon className="clickable-icon remove-icon" color="red" name="remove" onClick={() => this.removeDateRange(index)} />
            </div>
          </div>
        </Form.Group>
      );
    });
  };

  public render() {
    const { t } = this.props as any;

    const modalTitle = this.props.isClone ? 'Clone SSA Skill' : 'New SSA Question';
    return (
      <Modal className="tna-question-bank__modal" open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newQuestionBankStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('Loading')}</Loader>
        </Dimmer>
        <Modal.Header className="tna-squestion-bank__modal-header">{t(modalTitle)}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.newQuestionBankStore.state.result && !this.newQuestionBankStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newQuestionBankStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newQuestionBankStore.state.item && (
              <Form>
                <div className="tna-question-bank__wrapper scroll">
                  <Form.Group className="tna-question-bank__selctor-group">
                    <Form.Field className="tna-question-bank__label-input">
                      <label>{t('SSA Skill')}</label>
                      <SkillsEditor
                        nullable
                        skillType={SkillType.SSA}
                        className="planit-user-dropdown-custom"
                        placeholder={t('Select SSA Skill')}
                        value={this.state.skill}
                        onChange={s => this.handleValue(nameof<CreateSsaQuestionBankDto>('ssaSkillId'), s != null ? s.id : null)}
                        clearable
                      />
                    </Form.Field>

                    <Form.Field
                      required
                      className="tna-question-bank__label-input"
                      error={
                        (this.newQuestionBankStore.state.item.testCategoryId == null ||
                          isNullOrWhiteSpaces(this.newQuestionBankStore.state.item.testCategoryId)) &&
                        this.state.userClickedSave
                      }
                    >
                      <label>{t('Category')}</label>
                      <TestCategorySelector
                        nullable
                        isTnaCategory={false}
                        className="planit-user-dropdown-custom"
                        placeholder={t('Select Category')}
                        value={this.state.category}
                        onChange={category => this.handleValue(nameof<CreateSsaQuestionBankDto>('testCategoryId'), category?.id)}
                      />
                    </Form.Field>
                  </Form.Group>

                  <Form.Group className="tna-question-bank__selctor-group">
                    <Form.Field
                      required
                      className="tna-question-bank__label-input"
                      error={
                        (this.newQuestionBankStore.state.item.professions == null ||
                          this.newQuestionBankStore.state.item.professions.length === 0) &&
                        this.state.userClickedSave
                      }
                    >
                      <label>{t('Roles')}</label>
                      <MultiProfessionEditor
                        className="planit-user-dropdown"
                        placeholder={t('Roles')}
                        value={this.props.cloneData ? this.props.cloneData.professions.map(p => p.id) : []}
                        onChange={value => this.handleValue(nameof<CreateSsaQuestionBankDto>('professions'), value)}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group className="tna-question-bank__selctor-textarea">
                    <Form.Field
                      required
                      className="tna-question-bank__label-textarea"
                      error={this.state.userClickedSave && !this.newQuestionBankStore.state.item.question}
                    >
                      <label>{t('Question')}</label>
                      <TextArea
                        maxLength="500"
                        className="tna-question-bank__custom-editorequest__textarea"
                        value={this.newQuestionBankStore.state.item.question ? this.newQuestionBankStore.state.item.question.text : ''}
                        onChange={(e, { value }) => this.onChangeQuestion(value.toString())}
                      />

                      <Button
                        className="custom-table-add-row-btn add-row-btn"
                        type="button"
                        content="Add Row"
                        onClick={this.addQuestionsTranslation}
                      >
                        {String(i18n.t('Add Translation'))}
                      </Button>
                    </Form.Field>
                  </Form.Group>
                  {this.state.questionTranslations.length > 0 && <>{this.showQuestionTranslationRows()}</>}
                </div>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions className="new-tna-question-bank__btns">
          <Button onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewSsaQuestionBankView);
